<template>
  <div id="app" style="height: 100%">
    <div id="errorAlert">
      <b-alert :show="errorMessageDismissCountDown" variant="danger" dismissible>
        {{ errorMessage }}
      </b-alert>
    </div>

    <b-toast id="loadingToast" :title="$t('general.loading')" no-auto-hide v-model="isLoading" variant="secondary"
             :no-close-button="true">
      <div class="text-center">
        <b-spinner></b-spinner>
      </div>
    </b-toast>

    <b-toast id="notificationToast" :v-model="showNotification"
             :no-close-button="true">
      <div class="text-center">
        test
      </div>
    </b-toast>

    <HeaderTemplate :csrf-token="csrfToken"/>

    <router-view  :konfig-model="konfigModel"
                  :part-sizes="partSizes"
                  :request-inquiry-model="requestInquiryModel"
                  :request-quotation-model="requestQuotationModel"
                  :width-config="widthConfig"
                  :width3-d="width3D"
                  :csrf-token="csrfToken"/>

    <notifications position="top right" width="25%" style="margin:55px 10px 10px 10px">
      <template slot="body" slot-scope="props">
        <b-alert :variant="alertVariant(props.item.type)" show dismissible fade>
          <h5 class="alert-heading" v-if="isNotBlank(props.item.title)">{{props.item.title}}</h5>
          <div v-if="isNotBlank(props.item.text)">{{props.item.text}}</div>
        </b-alert>
      </template>
    </notifications>
  </div>
</template>

<script>
import Vue from 'vue';
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import UniqueId from 'vue-unique-id';
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import HeaderTemplate from "@/components/template/HeaderTemplate";
import isEmpty from "@/mixins/isempty"
import titleMixin from "@/mixins/titleMixin";
import collect from 'collect.js';
import voca from 'voca';

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(UniqueId);
Vue.use(VueAxios, axios);
Vue.use(Vuex);
Vue.use(VueRouter);

// Vue.use(VueMatomo, {
//   host: 'https://p552886.webspaceconfig.de/',
//   siteId: 2,
//   trackerUrl: '//p552886.webspaceconfig.de/matomo.php',
//   router: VueRouter,
//   enableLinkTracking: true,
//   enableHeartBeatTimer: true,
//   heartBeatTimerInterval: 10,
//   trackInitialView: true,
//   cookieDomain: '*.partnernet.mayr.de'
// })

//Nur aufm partnernet matomo tracken

export default {
  name: 'App',
  components: {
    HeaderTemplate
  },
  mixins: [isEmpty, titleMixin],
  data:
      function () {
        return {
          maxStuecklId: 0,
          overviewModel: {},
          isValidating: false,
          unsubscribe: {}
        };
      },
  computed: {
    konfigModel: function () {
      let konfigModel = this.$store.getters.konfigModel;
      if (konfigModel !== undefined) {
        if (konfigModel.i18nBenennung === undefined) {
          konfigModel.i18nBenennung = '';
        }
      }
      return konfigModel;
    },
    requestQuotationModel: function () {
      return this.$store.getters.requestQuotationModel;
    },
    requestInquiryModel: function () {
      return this.$store.getters.requestInquiryModel;
    },
    errorMessage: function () {
      return this.$store.getters.errorMessage;
    },
    errorMessageDismissCountDown: function () {
      return this.$store.getters.errorMessageDismissCountDown;
    },
    isLoading: function () {
      return this.$store.getters.isLoading;
    },
    inquiryModalVisible: function () {
      return this.$store.getters.isInquiryModalVisible;
    },
    showNotification: function () {
      if (this.$store.getters.showNotification) {
        this.$bvToast.toast(this.$store.getters.notificationContent.text, {
          variant: this.$store.getters.notificationContent.variant,
          title: this.$store.getters.notificationContent.title,
          noAutoHide: this.$store.getters.notificationContent.dontHide
        })
        this.$store.commit('removeNotification');
      }
      return false;
    },
    overviewResponse: function () {
      return this.$store.getters.overviewResponse;
    },
    partSizes: function () {
      let sizes = new Map();
      if (typeof this.konfigModel !== "undefined") {
        if (typeof this.konfigModel.stuecklistenInfos !== "undefined") {
          this.konfigModel.stuecklistenInfos.forEach(stueliInfo => {
            sizes.set(stueliInfo.id, stueliInfo.size);
          });
        }
      }
      return sizes;
    },
    csrfToken: function () {
      return this.$store.getters.csrfToken;
    },
    widthConfig: function () {
      return this.widthConfigMethod();
    },
    width3D: function () {
      return 12 - this.widthConfigMethod();
    }
  },
  methods: {
    rememberCookieConsentGiven(){
      this.trackCookieConsentGiven()
    },
    widthConfigMethod: function () {
      return (this.$store.getters.getUserData.anonym || this.$store.getters.getUserData.kunde) ? 6 : 8;
    },
    alertVariant(type) {
      if (collect(['warn', 'warning', 'warnung']).contains(type)) {
        return 'warning'
      }
      if (collect(['success', 'ok', 'erfolg']).contains(type)) {
        return 'success'
      }
      if (collect(['error', 'err', 'danger']).contains(type)) {
        return 'danger'
      }
      return 'info'
    },
    isNotBlank(str) {
      return !voca.isBlank(str)
    },
  },


  created() {
    this.unsubscribe = this.$store.subscribe((mutation) => {
      let noReloadMutationTypes = ['setKonfigModelAfterRequest', 'setKonfigModelTypenschluessel',
        'setKonfigModelValidationMode', 'setLoadingFlag', 'removeLoadingFlag', 'initModelByMaxStklId',
        'initModelBySizeType', 'initModelByArticleNo', 'initModel', 'setUserData', 'newCsrfToken', 'dismissErrorMessage',
        'setShowInquiryModal', 'setShowQuotationModal', 'setNotificationContent', 'showNotification',
        'removeDownloadFlag', 'setDownloadFlag', 'setValidating', 'removeNotification', 'setIsTestDatabaseEnabled','setIsTestRulesEnabled',
        'setProductBreadcrumb', 'setProductSizes', 'setProductTree', 'setDirectAccessVisibility', 'setProductTreeVisibility',
        'setProductList', 'resetSla', 'setSla', 'getItemFeatures'];
      if (noReloadMutationTypes.includes(mutation.type)) {
        //Dont do anything here. Except you want a endless loop or useless validations.
        return;
      }

      this.$store.commit('setKonfigModelValidationMode', 'MERKMALE');
      //Das Model muss nicht validiert werden, da wir uns auf der Welcome-Page befinden, Fallback redirected auf StartPage
      if(!(this.$route.name === 'StartPage' || this.$route.name === 'Fallback')){
        //console.log('validating because of mutation ' + mutation.type)
        this.$store.dispatch('validateKonfigModel');
      }
    });
  },

  mounted() {
    //Load UserData
    this.$store.dispatch('getUserDataWithOptionalAuthentication');
    this.$store.dispatch('isTestDatabaseEnabled');
    this.$store.dispatch('isTestRulesEnabled');
  },
  beforeDestroy() {
    this.unsubscribe();
  }

}
</script>

